const AddressPhone: React.FC = () => (
  <menu className="flex flex-col gap-y-1 md:w-1/2 lg:mb-8 lg:w-full">
    <li className="text-center">
      <a
        className="text-3xl text-blue hover:text-blue500"
        href="tel:8772857606"
      >
        (877) 285-7606
      </a>
    </li>
    <li className="text-nowrap text-center text-black100">
      Mon–Fri, 6:30 AM–5:00 PM PST
    </li>
    <li className="text-nowrap text-center text-black100">
      7509 S. 5th St. Ridgefield, WA 98642
    </li>
  </menu>
);

export default AddressPhone;
